var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2033_17700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2033_17700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 68.6699C12.8125 68.6699 11.7188 68.2012 10.7812 67.2637C9.84375 66.3262 9.375 65.2324 9.375 63.9824V16.873H14.0625V63.9824H51.0938V68.6699H14.0625ZM23.4375 59.2949C22.1875 59.2949 21.0938 58.8262 20.1562 57.8887C19.2188 56.9512 18.75 55.8574 18.75 54.6074V10.8574C18.75 9.60742 19.2188 8.51367 20.1562 7.57617C21.0938 6.63867 22.1875 6.16992 23.4375 6.16992H57.8125C59.0625 6.16992 60.1563 6.63867 61.0938 7.57617C62.0313 8.51367 62.5 9.60742 62.5 10.8574V54.6074C62.5 55.8574 62.0313 56.9512 61.0938 57.8887C60.1563 58.8262 59.0625 59.2949 57.8125 59.2949H23.4375Z",
    fill: "#B00041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilelogo);
export default __webpack_public_path__ + "static/media/filelogo.91fd8e5d624707b15e4381cc77c76ccd.svg";
export { ForwardRef as ReactComponent };